import * as Sentry from "@sentry/gatsby";

if (process.env.GATSBY_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.GATSBY_SENTRY_DSN,
    environment: process.env.GATSBY_SENTRY_ENVIRONMENT,
    release: process.env.GATSBY_SENTRY_RELEASE,
  });
}